// extracted by mini-css-extract-plugin
export default {"card":"Cr8UuE","active":"qhhewY"};